import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Permission, UserProfile } from '../interface/user-profile';

@Injectable({
  providedIn: 'root'
})
export class SessionServiceService {

  constructor(
    private http: HttpClient
  ) { }
  private permissionCodesSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  private permissionCodes$: Observable<string[]> = this.permissionCodesSubject.asObservable();
  private userProfileSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private userProfile$: Observable<any> = this.userProfileSubject.asObservable();

  setPermissionCodes(codes: string[]): void {
    this.permissionCodesSubject.next(codes);
  }

  getPermissionCodes(): Observable<string[]> {
    return this.permissionCodes$;
  }

  setUserProfile(profile: UserProfile): void {
    this.userProfileSubject.next(profile);
  }

  getUserProfile(): Observable<UserProfile> {
    return this.userProfile$;
  }

  async updatePermissionCodes(): Promise<void> {
    const response = await this.getSession();
    if (!response) {
      return;
    }
    const parsedResponse = JSON.parse(response) as { userProfile: UserProfile};
    this.userProfileSubject.next(parsedResponse.userProfile);
    const newPermissionCodes = parsedResponse.userProfile.roles
    .reduce((c: Permission[], i) => c.concat(i.permissions), [])
    .map(x => x.permissionCode);
    this.permissionCodesSubject.next(newPermissionCodes);
  }

  /**
   * get User Profile Session
   */
  getSession(): Promise<any> {
    const userProfile = this.http.get('/api/userprofile', {withCredentials: true}).toPromise();
    return userProfile;
  }
}
